// v1/teams
import { get } from "@/backend";
import useSWR from "swr";

interface TeamType {
  id: string;
  name: string;
  avatar: string;
  description: string;
  accepted: boolean;
  isCreator: boolean;
  subscription: string;
  members: {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    avatar: string;
    username: string;
    accepted: boolean;
  }[];
}

const useTeams = () => {
  const { data, error, mutate, isLoading } = useSWR("/v1/teams", get);

  return {
    teams: (data?.data?.data || data?.data || []) as TeamType[],
    loading: isLoading,
    error: error,
    mutate,
  };
};
export default useTeams;
